<template>
  <transition name="el-fade-in-linear">
    <div class="sn-bs-land-dialog" v-if="visibility">
      <el-button
        circle
        icon="el-icon-close"
        class="sn-bs-land-dialog__close-panel"
        size="mini"
        @click="handleClose"
      ></el-button>
      <div class="sn-bs-land-dialog__panel">
        <div class="sn-bs-land-dialog__panel-head">
          <div class="sn-bs-land-dialog__panel-title">
            <p class="sn-bs-land-dialog__panel-title-content">
              {{ landInfo.landName }}
            </p>
            <button
              v-if="landBroadenList"
              class="sn-bs-land-dialog__panel-title-badge"
              @click="visibilityLandFilesDialog = true"
            >
              <i class="iconfont icon-beizhuSVG"></i>
            </button>
          </div>
          <div class="sn-bs-land-dialog__panel-desc">
            <div>
              <p class="sn-bs-land-dialog__desc-content">
                占地面积：{{ landAcre }} 亩
              </p>
              <p class="sn-bs-land-dialog__desc-badge">
                {{ landInfo.landTypeName }}
              </p>
            </div>
            <el-button
              type="text"
              class="sn-bs-land-dialog__land-button"
              @click="toLandDetail"
              >进入地块<i class="el-icon-arrow-right"></i
            ></el-button>
          </div>
        </div>
        <div class="sn-bs-land-dialog__panel-body">
          <bs-scrollbar class="sn-bs-land-dialog__panel-scrollbar">
            <ul
              class="sn-bs-land-dialog__panel-list"
              v-if="landInfo.cropList && landInfo.cropList.length > 0"
            >
              <li
                class="sn-bs-land-dialog__panel-list-item"
                v-for="cropInfo in landInfo.cropList"
                :key="cropInfo.cropId"
              >
                <div class="sn-bs-land-dialog__list-side">
                  <div class="sn-bs-land-dialog__list-icon">
                    <img
                      class="sn-bs-land-dialog__list-icon-inner"
                      :src="setImgUrl(cropInfo.imgUrl)"
                      :alt="cropInfo.cropName"
                    />
                  </div>
                  <p class="sn-bs-land-dialog__list-name">
                    {{ cropInfo.cropName }}
                  </p>
                </div>
                <p class="sn-bs-land-dialog__list-desc">
                  {{ cropInfo.plantStartDate | dateFormatMapping("yyyy.MM.dd")
                  }}{{
                    cropInfo.cropSubjectIdentifier
                      | plantMethod(cropInfo.plantMethod)
                  }}
                </p>
              </li>
            </ul>
            <div class="sn-bs-land-dialog__empty" v-else>
              <p class="sn-bs-land-dialog__empty-tip">闲置中</p>
            </div>
          </bs-scrollbar>
        </div>
      </div>
      <bs-dialog
        title="地块档案"
        v-model="visibilityLandFilesDialog"
        :show-empty="!landBroadenList"
      >
        <div class="sn-bs-dialog__content">
          <div
            class="sn-bs-dialog__content-section"
            v-for="(info, i) in landBroadenList"
            :key="i"
          >
            <p class="sn-bs-dialog__content-section-title">
              {{ info.title }}
            </p>
            <div class="sn-bs-dialog__content-section-desc">
              <p
                class="sn-bs-dialog__content-inner"
                v-for="(item, j) in info.childList"
                :key="`${i}-${j}`"
              >
                {{ item.label }}：{{ item.value }}
              </p>
            </div>
          </div>
        </div>
      </bs-dialog>
    </div>
  </transition>
</template>

<script>
import BsDialog from "@/components/bs/BsDialog";
import BsScrollbar from "@/components/bs/BsScrollbar";
import { area2Mu, setImgUrl, dateFormatMapping } from "@/utils";
import { landBroaden } from "@/api/request/snkd.produce";
import { mapState } from "vuex";
import { BREED_METHOD_MAP } from "@/confing";

export default {
  name: "BsLandDialog",
  model: {
    prop: "visibility",
    event: "on-closed",
  },
  props: {
    visibility: {
      type: Boolean,
      default: false,
    },
    landInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      visibilityLandFilesDialog: false,
      // 扩展信息
      landBroadenList: undefined,
    };
  },
  methods: {
    handleClose() {
      this.$emit("on-closed", false);
    },
    setImgUrl,
    toLandDetail() {
      location.href = `/index.html#/home/plotdetail/company=${this.companyId}&farm=${this.farmId}&plotId=${this.landInfo.id}`;
    },
    // 父组件调用
    async getLandBroadenInfoController() {
      const res = await landBroaden.getService({
        companyId: this.landInfo.companyId,
        farmId: this.landInfo.farmId,
        landId: this.landInfo.id,
      });
      this.landBroadenList = res && res.remark && JSON.parse(res.remark);
    },
  },
  filters: {
    dateFormatMapping,
    plantMethod(cropSubjectIdentifier, type) {
      return BREED_METHOD_MAP[cropSubjectIdentifier][type];
    },
  },
  computed: {
    ...mapState(["farmId", "companyId"]),
    landAcre() {
      return this.landInfo.landAcre
        ? area2Mu(this.landInfo.landAcre, this.landInfo.landAcreUnit)
        : 0;
    },
  },
  watch: {
    visibility(val) {
      if (val) {
        this.$nextTick(() => {
          document.body.appendChild(this.$el);
        });
      }
    },
  },
  components: {
    BsScrollbar,
    BsDialog,
  },
};
</script>

<style scoped lang="scss">
@include bs(land-dialog) {
  position: fixed;
  z-index: 9997;
  top: 40vh;
  left: 50%;
  transform: translate(-50%, -90%);
  @include e(close-panel) {
    position: absolute;
    right: -10px;
    top: -10px;
    width: 20px;
    height: 20px;
    line-height: 20px;
    padding: 0;
    color: $--color-info;
    z-index: 2;
  }
  @include e(panel) {
    position: relative;
    width: 400px;
    height: 210px;
    box-shadow: 1px 1px 50px rgba(0, 0, 0, 0.3);
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: $--border-radius-base;
    overflow: hidden;
  }
  @include e(panel-head) {
    height: 80px;
    box-sizing: border-box;
    padding-top: 8px;
    background-color: #2cd2a9;
  }
  @include e(panel-title) {
    box-sizing: border-box;
    padding: 0 14px;
    margin-left: 10px;
    display: flex;
    align-items: center;
  }
  @include e(panel-title-content) {
    font-size: $--font-size-large;
    color: $--color-white;
    max-width: 324px;
    line-height: 35px;
    font-weight: bold;
    @include utils-ellipsis();
  }
  @include e(panel-title-badge) {
    padding: 0;
    outline: none;
    margin: 0;
    margin-left: 10px;
    border: 0 none;
    background-color: #ff9800;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    cursor: pointer;
    .iconfont {
      color: $--color-white;
    }
  }
  @include e(panel-desc) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 32px;
    padding: 0 20px;
    color: #e7f7f3;
  }
  @include e(desc-content desc-badge) {
    display: inline-block;
    font-size: $--font-size-base;
  }
  @include e(desc-badge) {
    padding: 0 7px;
    height: 18px;
    line-height: 18px;
    font-size: $--font-size-extra-small;
    background-color: #31bd9a;
    border-radius: 9px;
    margin-left: 8px;
  }
  @include e(land-button) {
    color: $--color-white;
  }
  @include e(panel-body) {
    height: calc(100% - 80px);
    box-sizing: border-box;
  }

  @include e(panel-list) {
    padding: 10px 20px 0;
  }
  @include e(panel-list-item) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 10px;
    height: 50px;
    box-shadow: 0 1px 3px -1px rgba(0, 0, 0, 0.3);
    margin-bottom: 10px;
    background-color: $--color-white;
    font-size: $--font-size-base;
  }
  @include e(list-side) {
    display: flex;
    align-items: center;
  }
  @include e(list-icon) {
    width: 30px;
    height: 30px;
    margin-right: 10px;
    border-radius: 50%;
    overflow: hidden;
  }
  @include e(list-icon-inner) {
    display: block;
    width: 100%;
    height: 100%;
  }
  @include e(list-name) {
    color: #2cd2a9;
    max-width: 190px;
    line-height: 1.5;
    @include utils-clearfix();
  }
  @include e(list-desc) {
    color: #999;
  }
  @include e(empty) {
    margin-right: 17px;
    height: calc(210px - 80px);
    background: url("~@/assets/images/bs/farm-detail/xiugengzhong.png")
      no-repeat center 20%;
  }
  @include e(empty-tip) {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    color: #999;
    font-size: $--font-size-medium;
    line-height: 40px;
    text-align: center;
  }
}
@include bs(dialog) {
  @include e(content) {
    width: 380px;
    margin: 15px auto;
  }
  @include e(content-section) {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    &:not(:first-child) {
      margin-top: 10px;
    }
  }
  @include e(content-section-title) {
    font-weight: bold;
  }
  @include e(content-section-desc) {
    width: 270px;
  }
}
.sn-bs-land-dialog__panel-scrollbar {
  ::v-deep {
    .el-scrollbar__thumb {
      background-color: $--scrollbar-background-color;
    }
  }
}
</style>
